import { Avatar } from "@/components/avatar";
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from "@/components/dropdown";
import { DropdownLogOut } from "@/components/DropdownLogOut";
import { Navbar, NavbarItem, NavbarSection, NavbarSpacer } from "@/components/navbar";
import { SearchNavbarItem } from "../Search";

interface MiraNavbarProps {
  session: {
    user: {
      account: number;
      entity: string;
      firstName: string;
      lastName: string;
      fullName: string;
      role: string;
      state: number;
    };
  } | null;
}

export function MiraNavbar({ session }: MiraNavbarProps) {
  return (
    <Navbar>
      <NavbarSection>
        <NavbarItem href="/">
          <img src="/avemio-logo.png" alt="Avemio Logo" className="h-8 w-auto" />
        </NavbarItem>
      </NavbarSection>
      <NavbarSpacer />
      <SearchNavbarItem />
      <NavbarSection>
        <Dropdown>
          <DropdownButton as={NavbarItem}>
            <Avatar 
              initials={session?.user ? `${session.user.firstName[0]}${session.user.lastName[0]}`.toUpperCase() : 'U'}
              className="size-9 bg-avemio-primary text-white" 
            />
          </DropdownButton>
          <DropdownMenu className="min-w-64" anchor="bottom end">
            <DropdownItem className="hover:cursor-pointer" href="/profile">
              <DropdownLabel>Profil</DropdownLabel>
            </DropdownItem>
            <DropdownItem className="hover:cursor-pointer" href="/settings">
              <DropdownLabel>Einstellungen</DropdownLabel>
            </DropdownItem>
            <DropdownDivider />
            <DropdownItem className="hover:cursor-pointer">
              <DropdownLogOut />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </NavbarSection>
    </Navbar>
  );
}
